import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Component, Mixins } from 'vue-property-decorator';

var TabItemComponent = /** @class */ (function (_super) {
    __extends(TabItemComponent, _super);
    function TabItemComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TabItemComponent.prototype.blurElement = function (element) {
        if (!element || !element.blur) {
            return;
        }
        element.blur();
    };
    TabItemComponent.prototype.onActiveChange = function () {
        if (!this.isActive) {
            this.blurElement(this.$refs.link);
        }
    };
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], TabItemComponent.prototype, "isActive", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], TabItemComponent.prototype, "href", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], TabItemComponent.prototype, "alignLeft", void 0);
    __decorate([
        Watch('isActive'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TabItemComponent.prototype, "onActiveChange", null);
    TabItemComponent = __decorate([
        Component({
            name: 'ui-tab-item',
        })
    ], TabItemComponent);
    return TabItemComponent;
}(Mixins(MagicConfigMixin)));

export default TabItemComponent;
